import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
//import images
import logoSm from "../assets/images/logo-sm.png"
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { Link, useNavigate } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import { dashboardAPI } from '../services/api';
import { loginSuccess } from '../slices/login/reducer';
import { logoutUser } from '../slices/login/thunk';
import axios from 'axios';

const ProfileDropdown = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userName, setUserName] = useState<string>("Admin");

    // Get user from login state - this comes from backend /auth/me endpoint (Keycloak data)
    const loginUserSelector = createSelector(
        (state: any) => state.login?.user,
        (user: any) => user
    );
    const loginUser = useSelector(loginUserSelector);

    // Function to update userName from user data
    const updateUserName = (user: any) => {
        if (user?.username) {
            // Username from Keycloak (preferred_username)
            setUserName(user.username);
        } else if (user?.email) {
            // Email from Keycloak as fallback
            setUserName(user.email);
        } else {
            // Fallback if no user data available
            setUserName("Admin");
        }
    };

    useEffect(() => {
        // Check if we have valid user data in Redux (not empty object)
        const hasValidUserData = loginUser && 
                                 (loginUser.username || loginUser.email) &&
                                 Object.keys(loginUser).length > 0;
        
        if (hasValidUserData) {
            updateUserName(loginUser);
            return;
        }

        // If no valid user data in Redux, fetch from backend
        // Check if we have a token (user is logged in)
        const authUser = sessionStorage.getItem("authUser");
        if (!authUser) {
            setUserName("Admin");
            return;
        }

        // Parse token to check if it exists
        try {
            const parsedAuth = JSON.parse(authUser);
            if (!parsedAuth.token && !parsedAuth.access_token) {
                setUserName("Admin");
                return;
            }
        } catch (e) {
            setUserName("Admin");
            return;
        }

        // Fetch user profile from backend
        const fetchUserProfile = async () => {
            try {
                console.log('🔍 Fetching user profile from /auth/me...');
                const userResponse: any = await dashboardAPI.getCurrentUser();
                const userData = userResponse?.data || userResponse;
                
                if (userData && (userData.username || userData.email)) {
                    // Update Redux state with fetched user data
                    dispatch(loginSuccess(userData));
                    console.log('🔍 User data:', userData);
                    // Update displayed name
                    updateUserName(userData);
                    console.log('✅ User profile fetched:', userData.username || userData.email);
                }
            } catch (error: any) {
                console.error('❌ Failed to fetch user profile:', error);
                // If fetch fails, try to get from sessionStorage as fallback
                try {
                    const storedUser = JSON.parse(authUser);
                    if (storedUser.username || storedUser.email) {
                        updateUserName(storedUser);
                    } else {
                        setUserName("Admin");
                    }
                } catch (e) {
                    setUserName("Admin");
                }
            }
        };

        fetchUserProfile();
    }, [loginUser, dispatch]); // Update when login state changes

    return (
        <React.Fragment>

            <Dropdown className="header-item">
                <Dropdown.Toggle type="button" className="btn bg-transparent border-0 arrow-none" id="page-header-user-dropdown">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={logoSm} alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block fw-medium user-name-text fs-16">{userName} <i className="las la-angle-down fs-12 ms-1"></i></span>
                        </span>
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-end">
                    <Dropdown.Item className="dropdown-item">
                        <Link style={{color:"black"}} to={`/user-profile`}>
                            <i className="bx bx-user fs-15 align-middle me-1"></i> <span key="t-profile">{t('Menu.profile')}</span>
                        </Link>
                      </Dropdown.Item>
                    <Dropdown.Item className="dropdown-item d-block">
                        <Link style={{color:"black"}} to={`/settings`}>
                            <i className="bx bx-wrench fs-15 align-middle me-1"></i> <span key="t-settings">{t('Menu.settings')}</span>
                        </Link>
                    </Dropdown.Item>
                    <div className="dropdown-divider"></div>
                    <Dropdown.Item 
                        className="dropdown-item text-danger" 
                        onClick={() => {
                            // Clear axios authorization header
                            delete axios.defaults.headers.common["Authorization"];
                            // Call logout thunk which will clear sessionStorage and redirect
                            dispatch(logoutUser(navigate));
                        }}
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="bx bx-power-off fs-15 align-middle me-1 text-danger"></i> <span key="t-logout">{t('Menu.logout')}</span>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </React.Fragment>
    );
}

export default ProfileDropdown;